/**
 * 设置 http 配置参数中 meta 参数的一些默认值
 *
 * meta 参数默认值
 * - appendParams 是否启用请求自动附加query或body参数
 * - showLoading 是否显示loading
 * - loadingDelayTime loading延迟显示时间
 * - showToast 是否显示toast
 * - isSilent 是否启用静默模式（启用后，强制关闭loading和toast）
 * - 异常状态码的黑(codeBlackList)/白名单(codeWhiteList)
 *
 * @since 1.0.0
 * @version 1.0.0
 */

import _ from 'lodash'

/**
 * @param {object} config - http 配置参数
 * @param {object} options - http实例配置参数
 * @returns {object} 返回更改后的config
 */
export default function httpMetaOptionsHandler(config, options) {
  // 初始化params为一个对象
  if (!_.isPlainObject(config.headers)) {
    config.headers = {}
  }

  if (!_.isPlainObject(config.params)) {
    config.params = {}
  }

  // see https://github.com/mzabriskie/axios/issues/86
  // 当body为空，axios不会设置Content-Type, 给data设置默认值{}，才能设置Content-Type
  // 初始化data为一个对象
  // 存在body为数组的情况
  if (!_.isArray(config.data) && !_.isPlainObject(config.data)) {
    config.data = {}
  }

  // 初始化meta为一个对象
  if (!_.isPlainObject(config.meta)) {
    config.meta = {}
  }

  // 相同接口是强制发起请求，默认都不强制发起
  if (!_.isBoolean(config.meta.forceRequest)) {
    config.meta.forceRequest = options.forceRequest
  }

  // 请求相同接口时是否对上一接口中止
  if (!_.isBoolean(config.meta.abortRequest)) {
    config.meta.abortRequest = options.abortRequest
  }

  // 是否阻止统一异常处理后的后续自定义错误处理流程
  if (!_.isBoolean(config.meta.preventCatch)) {
    config.meta.preventCatch = options.preventCatch
  }

  // 是否启用请求自动附加query或body参数
  if (!_.isBoolean(config.meta.appendParams)) {
    config.meta.appendParams = true
  }

  // 是否显示接口请求时的loading
  if (!_.isBoolean(config.meta.showLoading)) {
    config.meta.showLoading = true
  }

  // 是否显示异常时的toast
  if (!_.isBoolean(config.meta.showToast)) {
    config.meta.showToast = true
  }

  // 是否显示landing和toast
  if (!_.isBoolean(config.meta.isSilent)) {
    config.meta.isSilent = false
  }

  // 启用静默模式时，强制关闭loading和toast
  if (config.meta.isSilent) {
    config.meta.showToast = false
    config.meta.showLoading = false
  }

  // loading延迟显示时间
  if (!_.isLength(config.meta.loadingDelayTime)) {
    config.meta.loadingDelayTime = 300
  }

  // loading类型
  if (!_.isLength(config.meta.loadingType)) {
    config.meta.loadingType = 'scene'
  }

  // 黑名单
  if (!_.isArray(config.meta.codeBlackList)) {
    config.meta.codeBlackList = []
  }

  // 白名单
  if (!_.isArray(config.meta.codeWhiteList)) {
    config.meta.codeWhiteList = []
  }

  // 异常拦截名单，阻止进入用户自定义异常逻辑处理
  if (!_.isArray(config.meta.preventCodeList)) {
    config.meta.preventCodeList = []
  }

  // 储存已进行异常处理拦截的码名单，该项不开放配置，该项只提供初始化
  config.meta.catchCodeList = []

  return config
}
